import styled from '@emotion/styled'

export const DragAndDropArea = styled.div`
    height: 100%;
    margin-left: 40px;
    pointer-events: none;
    position: absolute;
    width: calc(100% - 40px);
`
